import React from "react";
import { StreamListItem, StreamListItemProps } from "../StreamListItem/StreamListItem";
import { LinkButton } from "app/links/LinkButton/LinkButton";
import { SlidingContainer } from "app/layout/SlidingContainer/SlidingContainer";

import "./styles.scss";
import { InstrumentListEntry } from "interfaces/v2/instrument";
import { withSectionBox } from "app/layout/Box/Box";

export interface StreamListProps {
    items: StreamListItemProps[] | InstrumentListEntry[];
    linkButtonUrl?: string;
    linkButtonTitle?: string;
}

function convertInstrumentListEntries(inItems: InstrumentListEntry[]): StreamListItemProps[] {
    return inItems.map((item) => ({
        name: item.title,
        isin: item.id,
        performance: item.performance,
        assetClass: item.assetClass
    }));
}

export const StreamList = ({ linkButtonUrl, linkButtonTitle, items }: StreamListProps) => {
    const workItems: StreamListItemProps[] = typeof (items[0] as InstrumentListEntry).idType !== "undefined"
        ? convertInstrumentListEntries(items as unknown as InstrumentListEntry[])
        : items as StreamListItemProps[];

    return (
        <SlidingContainer className="stream">
            {workItems.map((props, key) => (
                <StreamListItem {...props} key={key} />
            ))}
            {linkButtonUrl && linkButtonTitle && <LinkButton url={linkButtonUrl} title={linkButtonTitle} />}
        </SlidingContainer>
    );
};

export const StreamListV2 = withSectionBox<StreamListProps>(StreamList);
